<template>
  <div class="plant-section__plant">
    <img :src="plant.getPicturePath()">
    <h4>
      {{ plant.name }}
      <small>({{ plant.layerId }})</small>
    </h4>
    <div class="plant-section__description">Planted: {{ mapPlant.plantationDate }}</div>
  </div>
</template>

<script>
import MapPlant from '@/classes/MapPlant'

export default {
  name: 'MapPlantListItem',
  props: {
    mapPlant: { type: MapPlant, required: true },
  },
  computed: {
    plant () { return this.$store.getters.plant(this.mapPlant.plantId) },
  },
}
</script>
